<template>
  <div class="modal fade" :id="modalId" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          {{ message }}
        </div>
        <div class="modal-footer justify-content-center gap-2">
          <button type="button" class="btn btn-primary btn-back custom-p-2" data-bs-dismiss="modal">لغو</button>
          <button type="button" class="btn btn-primary btn-submit-1 custom-p-2" @click="confirmed">{{ title }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Modal} from "bootstrap";
import {v4 as uuid} from 'uuid'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      modalId: uuid()
    }
  },
  methods: {
    openConfirmModal() {
      const modal = Modal.getOrCreateInstance(document.getElementById(this.modalId));
      modal.show();
    },
    closeModal() {
      this.$emit('closed');
      const modal = Modal.getOrCreateInstance(document.getElementById(this.modalId));
      modal.hide();
    },
    confirmed() {
      this.$emit('confirmed');
      this.closeModal()
    }
  }
};
</script>
